import css from './index.module.scss';
import { useLang } from '@/i18n';

const E: React.FC = () => {
    const { t } = useLang('business.F');

    return (
        <section
            className={`${css.section} ${t('title')}-business-F GtmModuleData-section`}
            id={`${t('title')}-business-F`}
            data-section-id={`${t('title')}-business-F`}
            data-section-title={`${t('title')}-business-F`}
        >
            {/* <EcoSpace /> */}
            <div className={`info`}>
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>
                <div className="label">{t('label')}</div>
            </div>
        </section>
    );
};

export default E;
